import { ComponentPropsWithoutRef } from "react";
import cx from "classnames";

import styles from "./TableFooter.module.scss";

/**
 * Props for the TableFooter component
 * @extends ComponentPropsWithoutRef<"tfoot">
 * @extends ComponentPropsWithoutRef<"div">
 */
export type TableFooterProps =
  | ({
      /**
       * The type of table being rendered
       */
      type: "simple";
    } & ComponentPropsWithoutRef<"tfoot">)
  | ({
      /**
       * The type of table being rendered
       */
      type: "data-table";
    } & ComponentPropsWithoutRef<"div">);

/**
 * Table footer component for simple presentational or complex data tables
 * @param props - The props for the TableFooter component
 * @param props.type - The type of table being rendered
 * @param props.children - The children of the TableFooter component
 * @param props.ref - The ref of the TableFooter component
 */
export function TableFooter({ type, children, ...rest }: TableFooterProps) {
  const classes = cx(styles["table-footer"], rest.className);
  const Element = type === "simple" ? "tfoot" : "div";

  return (
    <Element
      {...rest}
      className={classes}
      role={type === "simple" ? undefined : "rowgroup"}
    >
      {children}
    </Element>
  );
}
